module.exports = __webpack_public_path__ + "crm_static/img/tips.7173254b.png";